import { useEffect, useState } from 'react';

const interestsOf = text => text.split(',').map(item => item.trim()).filter(Boolean);
const fieldsOf = profile => ({
  interests: (profile?.interests || []).join(', '),
  audience: profile?.audience || '',
  voice: profile?.voice_instructions || '',
  memory: !!profile?.memory_enabled,
});

// One profile's workspace settings (contract 2.0.0): interests, audience, voice and its
// memory choice, saved through PATCH /studio/profiles/{id}. Selecting another profile, or
// saving (a new version), starts again from the profile as stored.
export default function useProfileSettings(s, profile) {
  const [fields, setFields] = useState(() => fieldsOf(profile));
  useEffect(() => { setFields(fieldsOf(profile)); }, [profile?.id, profile?.version]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = key => value => setFields(previous => ({ ...previous, [key]: value }));
  const values = { interests: interestsOf(fields.interests), audience: fields.audience.trim() || null, voice_instructions: fields.voice.trim() || null, memory_enabled: fields.memory };
  const changed = !!profile && (values.interests.join('\n') !== (profile.interests || []).join('\n') || values.audience !== (profile.audience || null)
    || values.voice_instructions !== (profile.voice_instructions || null) || values.memory_enabled !== !!profile.memory_enabled);
  const ready = values.interests.length > 0 && changed;
  const submit = () => (ready ? s.saveProfile(profile, values) : Promise.resolve(false));
  return { ...fields, setInterests: set('interests'), setAudience: set('audience'), setVoice: set('voice'), setMemory: set('memory'), changed, ready, submit };
}
